import { SubscriptionInterval } from "@/models/subscriptionInterval";
import SubscriptionPlan from "@/models/subscriptionPlan";
//
// Production appsettings
const appSettingsProduction = class AppSettings {
  static VendorId = 110495;

  static DefaultSubscriptionInterval: SubscriptionInterval =
    SubscriptionInterval.Year;

  static AvailableSubscriptions: Array<SubscriptionPlan> = [
    new SubscriptionPlan(588287),
    new SubscriptionPlan(587849, "Save 25%"),
  ];

  static BaseUrl = "https://api.urlcheckr.com";

  //
  // Default accepted mimetypes
  static uploadAcceptedMimeTypes: Array<string> = [
    "text/csv",
    "text/plain",
    "text/*",
    "text/x-csv",
    "application/vnd.ms-excel",
    "application/csv",
    "application/x-csv",
    "text/comma-separated-values",
    "text/x-comma-separated-values",
    "text/tab-separated-values",
  ];
  //
  // Default maximum upload filesize (in bytes)
  static uploadMaximumFileSize = 5242880; // 5MB

  static MaximumRequestsPerBatch = {
    Free: 250,
    Premium: 99999999999999999999,
  };
};
//
// Development Appsettings
const appSettingsDev = class AppSettings {
  static VendorId = 109600;

  static DefaultSubscriptionInterval: SubscriptionInterval =
    SubscriptionInterval.Year;

  static AvailableSubscriptions: Array<SubscriptionPlan> = [
    new SubscriptionPlan(586017),
    new SubscriptionPlan(587987, "Save 25%"),
  ];

  static BaseUrl = "http://localhost:5000";

  //
  // Default accepted mimetypes
  static uploadAcceptedMimeTypes: Array<string> = [
    "text/csv",
    "text/plain",
    "text/*",
    "text/x-csv",
    "application/vnd.ms-excel",
    "application/csv",
    "application/x-csv",
    "text/comma-separated-values",
    "text/x-comma-separated-values",
    "text/tab-separated-values",
  ];
  //
  // Default maximum upload filesize (in bytes)
  static uploadMaximumFileSize = 5242880; // 5MB

  static MaximumRequestsPerBatch = {
    Free: 250,
    Premium: 99999999999999999999,
  };
};

export default process.env.NODE_ENV === "production"
  ? appSettingsProduction
  : appSettingsDev;
